import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { signOut as awsSignOut } from "../utils/awsCognito";

// AuthState 型を定義
interface AuthState {
  isAuthorized: boolean;
  email: string | null;
  userId: string | null;
  userName: string | null;
  loading: boolean;
  error: string | null;
}

// initialState を定義
const initialState: AuthState = {
  isAuthorized: false,
  email: null,
  userId: null,
  userName: null,
  loading: false,
  error: null,
};

export const signOut = createAsyncThunk(
  "auth/signOut",
  async (_props, { rejectWithValue }) => {
    const startTime = Date.now(); // 計測開始

    try {
      return await awsSignOut();
    } catch (error) {
      if (error instanceof Error) {
        return rejectWithValue(error.message);
      }
      return rejectWithValue(error);
    } finally {
      const endTime = Date.now(); // 計測終了
      console.log(`signOut execution time: ${endTime - startTime} ms`); // 実行時間をログ出力
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuthInfo: (state, action) => {
      state.email = action.payload.email;
      state.userId = action.payload.userId;
      state.userName = action.payload.userName;
      state.isAuthorized = true;
    },
    setUnauthorized: (state) => {
      state.email = null;
      state.userId = null;
      state.userName = null;
      state.isAuthorized = false;
    },
  },
  extraReducers: (builder) => {
    builder
      /**
       * サインアウト
       */
      .addCase(signOut.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(signOut.fulfilled, (state, action) => {
        state.email = null;
        state.userId = null;
        state.userName = null;
        state.isAuthorized = false;
        state.loading = false;
      })
      .addCase(signOut.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { setAuthInfo, setUnauthorized } = authSlice.actions;
export default authSlice.reducer;
